module.exports = __webpack_public_path__ + "static/media/Niveau_elN11_2_832861.980c8bbc.png";